import { useNavigate, useRouter, useSearch } from '@tanstack/react-router'
import { useCallback } from 'react'

export function useSearchParams() {
  const router = useRouter()
  const navigate = useNavigate()
  const searchParams = useSearch({ strict: false })

  const setSearchParam = useCallback(
    (key: string, value: string | undefined) => {
      const pathname = router.state.location.pathname
      const prev = router.state.location.search as Record<string, unknown>
      const next = { ...prev }
      if (value === undefined) {
        delete next[key]
      } else {
        next[key] = value
      }
      navigate({
        to: pathname,
        search: next,
        replace: true,
      })
    },
    [router, navigate],
  )

  const setSearchParams = useCallback(
    (updates: Record<string, string | undefined>) => {
      const pathname = router.state.location.pathname
      const prev = router.state.location.search as Record<string, unknown>
      const next = { ...prev }
      for (const [key, value] of Object.entries(updates)) {
        if (value === undefined) {
          delete next[key]
        } else {
          next[key] = value
        }
      }
      navigate({
        to: pathname,
        search: next,
        replace: true,
      })
    },
    [router, navigate],
  )

  return { searchParams, setSearchParam, setSearchParams }
}
